import React from 'react'
import CommonStoryCard from "../../../molecules/common-story-card";
import getStoriesByCollection from "../../../../utils";
import './subscription-explained.m.css'

export const SubscriptionExplained = ({data}) => {

    const subscriptionCollection = data.collection.collection.items[6]
    const stories = getStoriesByCollection(subscriptionCollection)

    return(
        <div styleName="subscription-explained-wrapper">
            <h2 styleName="summary">Newslaundry Explained</h2>
            <div styleName="subscription-collection">
                {stories.map(item=>{
                    return(                   
                        <CommonStoryCard story={item} key={item.id}/>                        
                    )
                })}
            </div>
        </div>
    )
}